import { MatDialogRef } from '@angular/material/dialog';

export class DialogStateModel {
  openDialog: MatDialogRef<any>;
}
